import type { documentAiApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

const apiBaseUrl = './documentai/api/v1'
const createDocumentHandler = http.post<object, documentAiApi.DocumentCreateRequest, documentAiApi.CreateResponse>(
  apiBaseUrl + '/documents',
  () => {
    return HttpResponse.json(
      {
        documentId: 'e1432a68-6bd7-4773-ab2c-453bf43573b1',
        documentUrl: `${apiBaseUrl}/customdocreateurl`,
        ttl: 1000,
      },
      { status: 201 },
    )
  },
)

const uploadDocumentHandler = http.put<object, object, object>(apiBaseUrl + '/customdocreateurl', () => {
  return HttpResponse.json(undefined, { status: 201 })
})

const deleteDocumentHandler = http.delete<documentAiApi.DocumentDeletePathParams, object, undefined>(
  apiBaseUrl + '/documents/:documentId',
  () => {
    return HttpResponse.text(undefined, { status: 204 })
  },
)

const beginAnalyzeHandler = http.post<documentAiApi.BeginDocumentAnalyzePathParams, object, documentAiApi.BeginAnalyzeResponse>(
  apiBaseUrl + '/documents/:documentId/uploaded/analyzeRequest',
  () => {
    return HttpResponse.json(
      {
        document: {
          dataSignature: 'SOaEgHlOMO95BUHYTwiKK-6qm9zvqL7YtM5pWHYFQlw',
          documentInfo: {
            dirty: false,
            entityId: 'EN1T5O04CXW0EAFWCZD9',
            fileUrl: '/documentai/api/v1/documents/e1432a68-6bd7-4773-ab2c-453bf43573b1/file',
            id: 'e1432a68-6bd7-4773-ab2c-453bf43573b1',
            locked: false,
            mimeType: 'image/png',
            name: 'fattura.png',
            scope: 'Refund',
            size: 230881,
            status: 'uploaded',
            type: 'mutuo',
          },
          documentInfoSignature: 'C-ibBsCmXKVhIHy7oHNygvNuUR--rBWzWdsCrl_AlKU',
        },
        operationId: 'de0cf732-b8cc-4441-a452-a600d7ef81e9',
        status: 'accepted',
      },
      { status: 201 },
    )
  },
)

const checkAnalyzeHandler = http.get<documentAiApi.AsyncAnalyzedResultPathParams, object, documentAiApi.Document>(
  apiBaseUrl + '/documents/:documentId/uploaded/analyzeResult/:operationId',
  () => {
    return HttpResponse.json({
      data: {
        customerAddress: {
          city: {
            originalValue: 'Roma',
            value: 'Roma',
          },
          houseNumber: {
            originalValue: '36',
            value: '36',
          },
          postalCode: {
            originalValue: '00144',
            value: '00144',
          },
          road: {
            originalValue: 'Viale Beethoven',
            value: 'Viale Beethoven',
          },
          stateDistrict: {},
          streetAddress: {},
        },
        customerAddressRecipient: {
          originalValue: 'Mario Rossi',
          value: 'Mario Rossi',
        },
        customerName: {
          originalValue: 'Mario Rossi',
          value: 'Mario Rossi',
        },
        customerTaxId: {
          originalValue: 'RSSMRA80A01H501U',
          value: 'RSSMRA80A01H501U',
        },
        invoiceDate: {
          originalValue: '2026-01-06T00:00:00Z',
          value: '2026-01-06T00:00:00Z',
        },
        dueDate: {
          originalValue: '2026-01-06T00:00:00Z',
          value: '2026-01-06T00:00:00Z',
        },
        invoiceId: {
          originalValue: 'KE2400008195',
          value: 'KE2400008195',
        },
        domiciliation: {
          value: 'true',
        },
        customerId: {
          value: 'CUSTOMER001',
        },
        pdr: {
          value: 'PDR001',
        },
        pod: {
          value: 'POD001',
        },
        invoiceTotal: {
          originalValue: 100,
          value: 100,
        },
        subTotal: {},
        totalTax: {
          originalValue: 24,
          value: 24,
        },
        vendorAddress: {
          city: {
            originalValue: 'Roma',
            value: 'Roma',
          },
          houseNumber: {
            originalValue: '175',
            value: '175',
          },
          postalCode: {
            originalValue: '00144',
            value: '00144',
          },
          road: {
            originalValue: 'Viale Europa',
            value: 'Viale Europa',
          },
          stateDistrict: {},
          streetAddress: {},
        },
        vendorAddressRecipient: {
          originalValue: 'POSTE SERVIZI',
          value: 'POSTE SERVIZI',
        },
        vendorName: {
          originalValue: 'POSTE SERVIZI',
          value: 'POSTE SERVIZI',
        },
        vendorTaxId: {
          originalValue: '02077281000',
          value: '02077281000',
        },
        canonerai: {
          originalValue: 11,
          value: 11,
        },
      },
      dataSignature: '2ZlnJbxGRmSi3h40NXkcmudKTeEcKb3HqPPKjTZC3qY',
      documentInfo: {
        dirty: false,
        entityId: 'EN1T5O04CXW0EAFWCZD9',
        fileUrl: '/documentai/api/v1/documents/3cdf0078-d6a7-4aaf-bc11-9b8e2075ec47/file',
        id: '3cdf0078-d6a7-4aaf-bc11-9b8e2075ec47',
        locked: false,
        mimeType: 'image/png',
        name: 'fattura.png',
        scope: 'Refund',
        size: 80792,
        status: 'analyzed',
        type: 'mutuo',
      },
      documentInfoSignature: 'WTi6ngmi53aSrmv7q380W97pR9howoKF3vMFwXnJ7g4',
    })
  },
)

export const documentAiHandlers = [
  createDocumentHandler,
  uploadDocumentHandler,
  beginAnalyzeHandler,
  checkAnalyzeHandler,
  deleteDocumentHandler,
]
